import { Injectable, signal } from '@angular/core';
import { PortalType } from '@shared';

/**
 * Portal Context Provider.
 *
 * Manages the current portal type context (Cases or Investigations) globally.
 * The portal type is extracted from the route by a resolver and stored here
 * for access throughout the application.
 */
@Injectable({ providedIn: 'root' })
export class PortalContextProvider {
  private readonly _currentPortalType = signal<PortalType>(PortalType.Cases);

  /**
   * Read-only signal for the current portal type.
   * Subscribe to this in components/services that need to know the current context.
   */
  public readonly currentPortalType = this._currentPortalType.asReadonly();

  /**
   * Sets the current portal type context.
   * Called by the portal context resolver when navigating between portals.
   *
   * @param portalType - The portal type to set (Cases or Investigations)
   */
  public setPortalType(portalType: PortalType): void {
    this._currentPortalType.set(portalType);
  }
}
